export const renewSession = async (tenantId = "") => {
    try {
        const renewRes = await fetch(
            `${process.env.WEB_API__ENDPOINT}/renew_session`,
            {
                credentials: "include",
                method: "POST",
                body: JSON.stringify({tenantId}),
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );

        if (renewRes.status === 401) {
            return false;
        } else {
            const res = await renewRes.json();
            return true;
        }
    } catch (e) {
        return false;
    }
};

export const activateUser = async (
    userActivationToken,
    auth0Token,
    allowMultipleTenants
) => {
    let response = {};
    try{
        const activateUserRes = await fetch(
            `${process.env.WEB_API__ENDPOINT}/activate_user`,
            {
                credentials: "include",
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    auth0Token,
                    userActivationToken,
                    allowMultipleTenants
                })
            }
        );
        switch (activateUserRes.status) {
            case 204:
                response.success = true;
                break;
            case 401:
                response = {
                    success: false,
                    status: "AlreadyLinked"
                };
                break;
            default:
                response = {
                    success: false,
                    status: "Failed"
                };
        }
        return response;
    }
    catch (e) {
        return {
            success: false,
            status: "Failed"
        };
    }

};

export const startSession = async (auth0Token, tenantId = "") => {
    // Always cleaning lastTenantId for startSession so we auth from scratch
    localStorage.removeItem("lastTenantId");
    const startSessionRes = await fetch(
        `${process.env.WEB_API__ENDPOINT}/start_session`,
        {
            credentials: "include",
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({auth0Token, tenantId: tenantId || '', firstLogin: true})
        }
    );
    if (startSessionRes.status === 401) {
        return {success: false, status: "MissingTenantId"};
    }
    if (startSessionRes.status === 403) {
        return {success: false, status: "unauthorized"};
    }
    if (startSessionRes.status === 200) {
        if (tenantId !== "") {
            localStorage.setItem("lastTenantId", tenantId);
        }
        const { csrfToken } = await startSessionRes.json();
    if (csrfToken) {
      window.localStorage.setItem("csrfToken", csrfToken);
    }return {success: true};
    }

    return {
        success: false
    };
};

export const startZendeskSession = async (auth0Token = "") => {
    const response = await fetch(`${process.env.WEB_API__ENDPOINT}/zendesk_start_session`, {
            credentials: "include",
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({auth0Token})
        });
    if (response.status === 403) {
        return {success: false, status: "unauthorized"};
    }
    if (response.status === 200) {
        const data = await response.json();
        return {success: true,data};
    }
    return {
        success: false
    };
};

export const getLinkedTenants = async (auth0Token, userActivationToken) => {
    const getLinkedTenantsRes = await fetch(
        `${process.env.WEB_API__ENDPOINT}/linked_tenants`,
        {
            credentials: "include",
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({auth0Token, userActivationToken})
        }
    );

    try {
        const data = await getLinkedTenantsRes.json();
        return {
            success: true,
            data,
            status: getLinkedTenantsRes.status
        };
    } catch (e) {
        return {
            success: false,
            data: [],
            status: getLinkedTenantsRes && getLinkedTenantsRes.status
        };
    }
};

export const verifyActivationToken = async userActivationToken => {
    const verifyActivationTokenRes = await fetch(
        `${process.env.WEB_API__ENDPOINT}/verify_activation_token`,
        {
            credentials: "include",
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({userActivationToken})
        }
    );

    if (verifyActivationTokenRes.status === 204) {
        return {
            success: true
        };
    }
    if (verifyActivationTokenRes.status === 403) {
        return {
            success: false,
            error: "Unauthorized"
        };
    }

    return {
        success: false,
        error: "Unknown error"
    };
};

export const sessionStatus = async () => {
    try {
        const csrfToken = window.localStorage.getItem("csrfToken");
        const res = await fetch(
            `${process.env.WEB_API__ENDPOINT}/session_status`,  {
                credentials: "include",
                headers: {
                    "X-CSRF-TOKEN": csrfToken || ""
                },  
                method: "GET"
            });
        return res.status === 204 || res.status === 200;
    } catch (e) {
        return false;
    }
};

export const logout = async () => {
    try {
            await fetch(`${process.env.WEB_API__ENDPOINT}/logout`, {
                credentials: "include",
                method: "POST",
                headers: {"Content-Type": "application/json"},
            });
            return true;
    } catch (e) {
        return false;
    }
}
